module.exports = "/info/img/developer1.png";